var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"custom-control custom-control-inline custom-checkbox"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"checkbox"},on:{"change":function($event){return _vm.action(_vm.data)}}}),_c('span',{staticClass:"custom-control-label"},[_vm._v(_vm._s(_vm.data.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }